import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { useAdvisorUserDetails } from '../AdvisorUserFormContext'
import RoundedModal from '../../../../molecules/RoundedModal'
import SydButton from '../../../../commonDesign/Button'
import DialogActions from '../../shared/DialogActions'

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: '30px',
    fontWeight: 800,
    textTransform: 'capitalize',
    padding: '14px 16px',
    width: '280px',
    marginRight: '10px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  cancelBtn: {
    backgroundColor: theme.palette.lightCoral,
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: '#f3b3be'
    }
  },
  confirmBtn: {
    backgroundColor: theme.palette.gray.light,
    color: theme.palette.lightBlack,
    '&:hover': {
      backgroundColor: theme.palette.gray.dark
    }
  },
  subtext: {
    fontWeight: theme.typography.weights.light,
    textAlign: 'left'
  }
}))

const DeleteDialog = forwardRef(function DeleteDialog ({ onConfirm }, ref) {
  const classes = useStyles()
  const { user } = useAdvisorUserDetails()
  const [open, setOpen] = useState(false)
  const handleConfirm = useCallback(async () => {
    await onConfirm(user)
    setOpen(false)
  }, [setOpen, onConfirm, user])

  useImperativeHandle(ref, () => {
    return {
      open: () => setOpen(true),
      close: () => setOpen(false)
    }
  }, [setOpen])

  return (
    <RoundedModal
      title='Deactivate User'
      open={open}
      onClose={() => setOpen(false)}
      disablePortal={false}
    >
      <div>
        <p>Are you sure you want to
          deactivate {user.firstName} {user.lastName} ({user.email})?
        </p>
        <p className={classes.subtext}>
          <span>Deactivated users</span>
          <ul>
            <li>Cannot log in</li>
            <li>Do not appear in the application</li>
            <li>Email addresses remain reserved by the system until they are permanently deleted</li>
          </ul>
        </p>
      </div>
      <DialogActions>
        <SydButton variant='ghost' onClick={() => setOpen(false)}>
          Cancel
        </SydButton>
        <SydButton variant='primary' priority='warning' icon='delete' onClick={handleConfirm}>
          Deactivate
        </SydButton>
      </DialogActions>
    </RoundedModal>
  )
})

DeleteDialog.propTypes = {
  onConfirm: PropTypes.func
}

export default DeleteDialog
